module.exports = __webpack_public_path__ + "static/blog-plane-389b29c9bd6bdcddae55a01e98712344.svg";